import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { BzgModalService } from 'bz-genome-angular';
import { ChangeAdministratorDialogComponent } from './change-administrator-dialog/change-administrator-dialog.component';
import { AuthClient } from 'app/auth/auth.client';
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';


@Component({
    selector: 'change-administrator',
    templateUrl: 'change-administrator.component.html',
    styleUrls: ['change-administrator.component.scss']
})
export class ChangeAdministratorComponent {
    public userName = '';

    constructor(private _translateService: TranslateService,
        private _autoLoginClient: AutoLoginClient,
        private _modalService: BzgModalService,
        private _authClient: AuthClient,
        private _i18nService: I18nService,
        private _showToastService: ShowToastService) { }

    ngOnInit() {
        this._autoLoginClient.getProfile()
            .subscribe((response) => {
                this.userName = response && response.username ? response.username : '';
            });
    }

    public changeAdministrator() {
        const deleteModal =  this._modalService.open(
          ChangeAdministratorDialogComponent,
          {closeOnBackdropClick: false, closeOnRouterNavigation: true}
        );
        deleteModal.afterClosed().subscribe((result: any) => {
            if (result && result.userName) {
                this._autoLoginClient.changeAdministrator(result.userName)
                    .subscribe((response) => {
                        switch (response) {
                            case 'ChangeAdministratorSucessful':
                                this.userName = result.userName;
                                break;
                                case 'ChangeAdministratorUsernameInUse':
                                this._showToastService.showToast(this._i18nService.instant('CHANGE_ADMINISTRATOR.SELECT_OTHER_EMAIL'), 'error');
                                break;
                                case 'ChangeAdministratorUnexpectedError':
                                this._showToastService.showToast(this._i18nService.instant('GLOBAL.GENERIC_ERROR_MSG'), 'error');
                                break;
                            default:
                                break;
                        }
                    });
            }
        })
    }
}
